module.exports = __webpack_public_path__ + "img/Aizhinengqicao.aeb5cac8.png";